import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "background-decoration" }
const _hoisted_3 = { class: "floating-particles" }
const _hoisted_4 = { class: "login-container" }
const _hoisted_5 = { class: "login-card" }
const _hoisted_6 = { class: "login-form" }
const _hoisted_7 = { class: "form-actions" }
const _hoisted_8 = { class: "card-footer" }
const _hoisted_9 = { class: "login-version" }
const _hoisted_10 = { class: "version-main" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
// 注意：Hpsfir* 组件一律**不要手动 import**。
// 框架会把组件按 __name 全局注册，并且**主题会用自己的实现再注册一遍**
// （registerUiComponents → registerProComponents → registerThemeComponents，
//  同名后者覆盖前者）。手动 import 拿到的是基座/默认主题那份，
// 会绕过主题覆盖 —— 页面要用主题组件就只能靠全局注册。
// 这里只 import 非组件的东西：函数（message）、组合式函数、以及类型。
import {
  useBaseUserStore,
  useRoute,
  useRouter,
  type HpsfirProFormInstance,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandLogin',
  setup(__props) {


/**
 * 品牌登录页（1.0.0 主题体系下的 LoginView 覆写）。
 *
 * 1.0.0 起框架不再暴露 loginCnt 选项，登录页改为「主题组件」：
 * 自定义主题 extend 内置主题后，用 registerThemeComponents 覆写同名组件即可。
 * 这里保留原有视觉设计（蓝金渐变背景 + 装饰粒子 + 卡片），
 * 仅把 Element Plus 的按钮/图标换成框架自带的 HpsfirButton。
 */
const baseUserStore = useBaseUserStore();
const router = useRouter();
const route = useRoute();
const loading = ref(false);

const versionText = computed(() => {
  const version = process.env.VUE_APP_PACKAGE_VERSION || '1.0.0';
  const env = process.env.VUE_APP_VERSION === 'test' ? '测试版' : '正式版';
  return `v${version} · ${env}`;
});

// 用框架导出的实例类型，不要用 InstanceType<typeof 组件>：组件已不再手动 import
// （手动 import 会绕过主题覆盖），脚本里拿不到组件值就推不出类型。
const formRef = ref<HpsfirProFormInstance>();
const loginFormItems: HpsfirProFormItem[] = [
  {
    // 1.0.0 起后端登录参数由 userNameOrPhone 改为 account（用户名/邮箱/手机号三合一）
    name: 'account',
    type: 'string',
    label: '账号',
    placeholder: '请输入用户名或手机号',
    rule: [{ required: true, message: '请输入账号' }],
  },
  {
    name: 'password',
    type: 'password',
    label: '密码',
    placeholder: '请输入密码',
    rule: [{ required: true, message: '请输入密码' }],
  },
];

const handleLogin = async(data: any) => {
  loading.value = true;
  try {
    await baseUserStore.login(data.account, data.password);
    if (route.query.back) {
      await router.replace(route.query.back as string);
      return;
    }
    await router.replace('/');
  } finally {
    loading.value = false;
  }
};

const submit = () => {
  formRef.value?.submit();
};

// 回车提交（原先依赖 @vueuse/core 的 onKeyStroke；
// 该包是 Element Plus 的传递依赖，随其移除而不可用，这里用原生监听替代）
const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    formRef.value?.submit();
  }
};

onMounted(() => {
  window.addEventListener('keydown', onKeydown);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown);
});

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProForm = _resolveComponent("HpsfirProForm")!
  const _component_HpsfirButton = _resolveComponent("HpsfirButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "gradient-bg" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (i) => {
          return _createElementVNode("div", {
            class: "particle",
            key: i
          })
        }), 64))
      ]),
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"geometric-shapes\" data-v-8bc796f0><div class=\"shape shape-1\" data-v-8bc796f0></div><div class=\"shape shape-2\" data-v-8bc796f0></div><div class=\"shape shape-3\" data-v-8bc796f0></div><div class=\"shape shape-4\" data-v-8bc796f0></div></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("h1", { class: "welcome-title" }, "欢迎登录"),
          _createElementVNode("p", { class: "welcome-subtitle" }, "驿站助手管理后台")
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_HpsfirProForm, {
            items: loginFormItems,
            "hide-cancel": "",
            "hide-ok": "",
            "hide-colon": "",
            "on-ok": handleLogin,
            ref_key: "formRef",
            ref: formRef,
            class: "form-container"
          }, null, 512),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_HpsfirButton, {
              class: "login-button",
              disabled: loading.value,
              onClick: submit
            }, {
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "button-icon" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    width: "16",
                    height: "16",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "7",
                      r: "4"
                    })
                  ])
                ], -1)),
                _createTextVNode(" " + _toDisplayString(loading.value ? '登录中…' : '登录'), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "footer-text" }, "安全登录 · 数据保护", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(versionText.value), 1)
          ])
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"side-decoration\" data-v-8bc796f0><div class=\"tech-circles\" data-v-8bc796f0><div class=\"circle circle-1\" data-v-8bc796f0></div><div class=\"circle circle-2\" data-v-8bc796f0></div><div class=\"circle circle-3\" data-v-8bc796f0></div></div><div class=\"tech-lines\" data-v-8bc796f0><div class=\"line line-1\" data-v-8bc796f0></div><div class=\"line line-2\" data-v-8bc796f0></div><div class=\"line line-3\" data-v-8bc796f0></div></div></div>", 1))
  ]))
}
}

})